import styled from 'styled-components';

const StyledInput = styled.input.attrs({ type: 'text' })`
	position: relative;
	max-width: 100%;
	padding: 10px;
	border-width: 0;
	border-radius: 4px;
	background-color: #202020;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: 500;
	color: #e6e6e6;

	&:focus {
		outline: none;
	}
`;

export { StyledInput };
